import { differenceInCalendarDays } from 'date-fns';

export default function simpleFormatDateDifference(date: Date | null): string | undefined {
  if (!date) return undefined;

  const dayDiff = differenceInCalendarDays(date, new Date());

  return dayDiff < 0 ? `d${dayDiff}` : `d+${dayDiff}`;
}
